import React from 'react';

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-gray-500">
          © 2025 Clicsoft. All rights reserved.
        </div>
      </div>
    </footer>
  );
}